module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAB6SURBVFiF7da7DYAgFIXhH+MgjOISWllYMBY+CitdwlHcBFtjbLghoTmnvMk9fAkUOAxZ4n4k6N+zBGcI45Db1VgAJSOAAAIIIEB1gJvjvhr2OsB/Zjdw5Ra1wGQA/MVbuqpfgQAtsBn2ij1CZzhcXzIBBBBAAAGK5gFqVhY+f9M4GgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-upload/images/plus.png
// module id = Jvgt
// module chunks = 7